module.exports = __webpack_public_path__ + "img/sd.4b00c4cf.png";